/* author:xx;
 *  date:2023/3/15;
 *  explan:优惠券相关api；
 *  desc:包含活体  商品 洗美服务 医疗服务 寄养服务  住院服务  各种套餐等
 */
import api from "./api.js";

let baseURL_1 = process.env.VUE_APP_Url_member; // 8002；
let baseURL_2= process.env.VUE_APP_apiHost; // 8010
// 获取用户可用优惠券列表
export function getetMemberCanUseCoupon(params) {
	return api.post(`${baseURL_1}/api/middleware/Coupon/GetMemberCanUseCoupon`, params)
} 
// 获取用户所有优惠券列表
export function getallMemberCanUseCoupon(params) {
	return api.post(`${baseURL_1}/api/middleware/Coupon/MList`, params)
} 
//获取优惠金额
export function getActivityPrice(params) {
	return api.post(`${baseURL_2}api/Order/CalcGoodsActivityPrice`, params)
} 
